"use client";
import axios from "axios";
import { useCountdown } from "hooks/useCountdown";
import { useOTPNew } from "hooks/useUser";
import { usePathname, useRouter } from "next/navigation";
import React, { useState } from "react";
import { FiLoader } from "react-icons/fi";
import useSWRMutation from "swr/mutation";
import styles from "./login.module.css";
import { useToast } from "./notifications";

async function verify(
  url: string,
  {
    arg,
  }: {
    arg: any;
  }
) {
  return axios.post(url, arg, {
    headers: {
      "Content-Type": "application/json",
    },
  });
}

export function VerifyEmail({
  change,
  email,
}: {
  change?: () => void;
  email: string;
}) {
  const router = useRouter();
  const toast = useToast();

  const { isMutating, trigger, error } = useSWRMutation(
    "auth/otp/verify/",
    verify,
    {
      onSuccess() {
        toast({
          text: "Email verified successfully",
          type: "success",
        });
        if (change) {
          change();
        } else {
          router.replace("/login");
        }
      },
    }
  );
  const [otp, setOtp] = useState("");
  return (
    <>
      <h1
        style={{
          textAlign: "center",
        }}
      >
        Welcome
      </h1>
      <p
        style={{
          textAlign: "center",
        }}
      >
        Verify your account with the OTP sent to your email address
      </p>
      <form
        className={styles.form}
        onSubmit={(e) => {
          e.preventDefault();
          trigger({ otp });
        }}
      >
        <label className="sr-only" htmlFor="otp">
          OTP
        </label>
        <input
          type="text"
          name="otp"
          value={otp}
          onChange={(e) => {
            setOtp(e.target.value);
          }}
          maxLength={6}
          id="otp"
          placeholder="Type the OTP"
          required
          pattern="\d{6}"
          title="OTP must be 6 digits"
        />
        {(typeof error === "string" ||
          (Array.isArray(error) &&
            error.every((a) => typeof a === "string"))) && (
          <p className="alert alert-danger text-red-500" role="alert">
            {error}
          </p>
        )}
        <button
          disabled={isMutating}
          type="submit"
          className="btn btn-lg btn-black"
        >
          {isMutating && <FiLoader className="animate-spin" />}
          Verify your Account
        </button>
        <p>
          Didn&apos;t receive the OTP? <ResetButton email={email} />
        </p>
      </form>
    </>
  );
}

export default VerifyEmail;

function ResetButton({ email }: { email: string }) {
  const [countdown, resetCountdown] = useCountdown(60);

  const sendOTP = useOTPNew();

  if (countdown > 0) {
    return (
      <button type="button" className="btn btn-sm btn-green-outline" disabled>
        Resend OTP in {countdown} seconds
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={async () => {
        await sendOTP.trigger({ email });
        resetCountdown();
      }}
      className="btn btn-sm btn-green-outline"
    >
      {sendOTP.isMutating && <FiLoader className="animate-spin" />}
      Resend OTP
    </button>
  );
}
